import { render } from "./view-dashboard.vue?vue&type=template&id=6a189f1e&scoped=true"
import script from "./view-dashboard.vue?vue&type=script&lang=js"
export * from "./view-dashboard.vue?vue&type=script&lang=js"

import "./view-dashboard.vue?vue&type=style&index=0&id=6a189f1e&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a189f1e"]])

export default __exports__